import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import * as Store from './../../store';

import template from './login.vue';

interface UserCheck {
    auctionUserStatus: number;
}

@Component({
    mixins: [template],
})
export default class LoginUser extends ComponentWithSocket {
    private username: string;
    private password: string;

    redirectAuctionId?: string;

    data: UserCheck = {
        auctionUserStatus: 0,
    };

    constructor() {
        super();

        this.username = '';
        this.password = '';

        // Assign session values to store for global dispatch
        this.wsListener.onPost('auth.login', (success: boolean, data: any) => {
            if (!success) {
                Store.commitLoaderVisibility(this.$store, false);
                return alert(data);
            }

            // Save the user data to localstorage
            this.wsListener.setAuthState(true, data);

            // Wait few ms to write the things
            setTimeout(() => {
                Store.commitLoggedInState(this.$store, true);
                Store.commitLoggedInUser(this.$store, data);

                this.wsListener.reconnect(() => {
                    if (data.isAdmin) {
                        window.location.href = 'admin-stage.vikart.ro';
                        return;
                    }

                    if (!this.$root.$options || !this.$root.$options.router) {
                        alert('Please refresh the page!');
                        return;
                    }

                    this.afterLoginRedirect();
                });
            }, 100);
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    afterLoginRedirect() {
        if (!this.$root.$options || !this.$root.$options.router) return;

        // Pagina ceruta inainte de login (pusa de guard); doar cai interne, nu alte domenii
        const redirect = new URL(window.location.href).searchParams.get(
            'redirect',
        );

        if (redirect && redirect.charAt(0) === '/' && redirect.charAt(1) !== '/') {
            this.$root.$options.router.push(redirect);
        } else if (this.redirectAuctionId) {
            // If logged in and auction id is present, redirect to auction page
            this.$root.$options.router.push(
                '/auction/' + this.redirectAuctionId,
            );
        } else {
            // Redirect to my account when logged in and no auctionId
            this.$root.$options.router.push('/account');
        }
    }

    mounted() {
        let url = new URL(window.location.href);
        this.redirectAuctionId = url.searchParams.get('auction')
            ? url.searchParams.get('auction')
            : this.$store.state.currentAuctionID;

        if (Store.readLoggedInState(this.$store)) {
            this.afterLoginRedirect();
        }
    }

    doLogin() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('auth.login', {
            user: this.username,
            pass: this.password,
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/login/index.ts